import React from 'react';
import { RotateCcw } from 'react-feather';
import { useNavigate } from 'react-router-dom';

import Paging from '@/shared/components/Common/Paging';
import SearchBar from '@/shared/components/Common/SearchBar';
import { useInitialPage } from '@/shared/hooks/useInitialPage';
import { useOrderList } from './hooks/useOrderList';

import OrderListTable from './components/UI/OrderListTable';
import { PaymentStatusFilter } from './types/orderTypes';

const OrderListPage: React.FC = () => {
  useInitialPage();
  const navigate = useNavigate();

  const {
    orders,
    totalPages,
    isLoading,
    currentPage,
    searchKeyword,
    paymentStatusFilter,
    setCurrentPage,
    handleSearch,
    handlePaymentStatusChange,
    handleRefresh,
    resetFilters,
  } = useOrderList();

  const movedToDetail = (orderUuid: string) => {
    navigate(`/orders/${orderUuid}`);
  };
  const moveToCreateOrder = () => {
    navigate('/orders/create');
  };

  const handlePaymentStatusSelectChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    handlePaymentStatusChange(e.target.value as PaymentStatusFilter);
  };

  return (
    <div className="min-h-screen bg-[#F1F1F1]">
      <div className="px-8 pt-6">
        <h2 className="text-2xl font-bold">Order</h2>

        <div className="mb-5 flex justify-end gap-2">
          <button
            type="button"
            className="flex h-7 w-7 cursor-pointer items-center justify-center rounded bg-[#E2E2E2]"
            onClick={resetFilters}
            disabled={isLoading}
          >
            <RotateCcw size={16} className="text-[#1D1D1D]" />
          </button>

          <select
            className="w-40 cursor-pointer rounded bg-[#E2E2E2] px-2 py-1 text-xs text-[#1D1D1D]"
            value={paymentStatusFilter}
            onChange={handlePaymentStatusSelectChange}
          >
            <option value="ALL">All Status</option>
            <option value="PENDING">Pending</option>
            <option value="CANCELLED">Cancelled</option>
            <option value="PAID">Paid</option>
          </select>

          <button
            type="button"
            className="cursor-pointer rounded bg-[#1D1D1D] px-3 py-1 text-sm font-medium text-white transition-colors hover:bg-opacity-80"
            onClick={moveToCreateOrder}
          >
            Create Order
          </button>
        </div>

        <SearchBar onSearch={handleSearch} initialValue={searchKeyword} />

        <OrderListTable
          orders={orders}
          isLoading={isLoading}
          movedToDetail={movedToDetail}
        />

        <div className="flex-none border border-x-[#DEDEDE] bg-[#E8E8E8] pb-4 pt-3">
          <Paging
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPage={totalPages}
          />
        </div>
      </div>
    </div>
  );
};

export default OrderListPage;
